export const printPdfPaymentList = (activePaymentData,selectedProjectName) => {
    const restructuredData = activePaymentData.map((record) => {
     const {
       to_date,
       totalPayment,
       morningPayment,
       number_of_days,
       overtimePayment,
       afternoonPayment,
       from_date,
       holidayPayment,
     } = record;
     const { first_name, father_name } = record.labor;
     const convertedToDate = new Date(to_date).toLocaleDateString();
     const convertedFromDate = new Date(from_date).toLocaleDateString();
     return {
       Name: first_name + ' ' + father_name,
       From: convertedFromDate,
       To: convertedToDate,
       Day: number_of_days,
       Payment: (afternoonPayment + morningPayment),
       OverTime: overtimePayment, 
       Holiday: holidayPayment, 
       Total: totalPayment, 
       Sign: ""
     };
   });
 
   const data = restructuredData;
   // Create a string variable to hold the HTML content of the table
   let tableContent = `
     <table>
       <thead>
         <tr>
           <th>#</th>${Object.keys(data[0]).map((key) => `<th>${key}</th>`).join('')}
         </tr>
       </thead>
       <tbody>
         ${data.map((item, index) => `
           <tr>
             <td>${index + 1}</td>${Object.values(item).map((value) => `<td>${value}</td>`).join('')}
           </tr>
         `).join('')}

         <tr>
         <th scope="row" colspan="5" class="text-left">
           Total
         </th>
         <td>
           ${data.reduce((sum, item) => sum + item.Payment, 0).toFixed(2)}
         </td>
         <td>
           ${data.reduce((sum, item) => sum + item.OverTime, 0).toFixed(2)}
         </td>
         <td>
           ${data.reduce((sum, item) => sum + item.Holiday, 0).toFixed(2)}
         </td>
         <td colspan="2">
           ${data.reduce((sum, item) => sum + item.Total, 0).toFixed(2)}
         </td>
       </tr>
       </tbody>
     </table>
   `;
   const currentDate = new Date();
   const formattedDate = currentDate.toLocaleDateString();
   const printWindow = window.open('', '_blank');
   printWindow.document.open();
   printWindow.document.write(`
     <html>
       <head>
         <style>
           body {
             margin: 1% 3%;
           }
           table {
             border-collapse: collapse;
             width: 100%;
           }
           th, td {
             border: 1px solid black;
             padding: 8px;
             text-align: left;
           }
           .header {
             text-align: center;
             font-weight: bold;
             margin-bottom: 20px;
           }
           .footer {
             margin-top: 20px;
           }
           .top-right {
             position: absolute;
             top: 0;
             right: 5%;
           }
         </style>
       </head>
       <body>
         <div class="top-right">
           <p>Printed Date: ${formattedDate}</p>
         </div>
         <div class="header">
           <h4> B Square Y Engineering  </h4>
           <h3> ቢ ስኴር ዋይ ኢንጂነሪንግ</h3>
           <h4>${selectedProjectName} project Labor Attendance Payment Card</h4>
         </div>
         ${tableContent}
         <div class="footer">
           <p>Approved BY  <u> ${activePaymentData[0].approved_by} </u>  Checked BY________________</p>
         </div>
       </body>
     </html>
   `);
   printWindow.document.close();
   printWindow.onload = () => {
   printWindow.print();
   };
 };